export default __webpack_public_path__ + "static/media/cito_logo.e4185544.svg";